<section id="secao-empresas" class="pt-5 pb-5">
  <div class="container">
    <div class="row cabecalho pt-5 pb-5">
      <div class="col">
        <h1 class="titulo">{{ getTitulo() }}</h1>
      </div>
      <div class="col hr">
        <hr />
      </div>
    </div>
    <div class="row">
      <div class="spinner-border" role="status" *ngIf="loading">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="col-md-3 logos" *ngFor="let e of arrEmpresas">
        <a [href]="e.link" target="_blank" data-toggle="tooltip" data-placement="top"
          [title]="e.nome">
          <img [src]="e.imagens[0].signedUrl" class="logo mt-1 mb-1 m-4" [alt]="e.nome" [title]="e.nome" />
        </a>
      </div>
    </div>
    <div class="alert alert-danger" role="alert" *ngIf="hasError">
      Desculpe, não foi possível encontrar o conteúdo de {{ getTitulo() }}
    </div>
  </div>
</section>